import getConfig from 'next/config';

const { publicRuntimeConfig } = getConfig();

const GOOGLE_CLIENT_ID = publicRuntimeConfig.googleOauthClientId;
const GOOGLE_REDIRECT_URL = publicRuntimeConfig.googleOauthRedirectUrl;

export const signInWithGoogle = (onError) => {
  window.gapi.load('auth2', () => {
    window.gapi.auth2
      .init({
        client_id: GOOGLE_CLIENT_ID
      })
      .then(() => {
        window.gapi.auth2
          .getAuthInstance()
          .grantOfflineAccess({
            ux_mode: 'redirect',
            redirect_uri: GOOGLE_REDIRECT_URL
          })
          .then(
            // These are never called in redirect mode.
            (res) => console.log(res),
            (err) => {
              console.log(err);
            }
          );
      })
      .catch((err) => {
        console.log(err);
        if (err.details.includes('Cookies are not enabled in current environment')) {
          onError(true);
        } else {
          onError(false);
        }
      });
  });
};
